export const APPLICANT_IDS_TO_CHANGE_SET = 'APPLICANT_IDS_TO_CHANGE_SET';

export const ORDER_RECEIVE = 'ORDER_RECEIVE';

export const ORDER_UPDATE = 'ORDER_UPDATE';

export const RESET_NEW_ORDER_DATA = 'RESET_NEW_ORDER_DATA';

export const CLREAR_NEW_ORDER_EXPRESS_LIST = 'CLREAR_NEW_ORDER_EXPRESS_LIST';

export const DELETE_NEW_ORDER_APPLICANT = 'DELETE_NEW_ORDER_APPLICANT';

export const IMPORT_NEW_ORDER_APPLICANTS = 'IMPORT_NEW_ORDER_APPLICANTS';

export const CLEAR_NEW_ORDER_APPLICANT_MSG = 'CLEAR_NEW_ORDER_APPLICANT_MSG';

export const CLEAR_NEW_FLIGGY_ORDER_APPLICANT_MSG = 'CLEAR_NEW_FLIGGY_ORDER_APPLICANT_MSG';

export const SET_APPLICANT_MSG = 'SET_APPLICANT_MSG';

export const SELECT_NEW_ORDER_DEPART_DATE = 'SELECT_NEW_ORDER_DEPART_DATE';

export const ADD_NEW_ORDER_APPLICANT = 'ADD_NEW_ORDER_APPLICANT';

export const UPDATE_APPLICANT_NAME = 'UPDATE_APPLICANT_NAME';

export const UPDATE_APPLICANT_IDENTITY = 'UPDATE_APPLICANT_IDENTITY';

export const UPDATE_OTA_ID = 'UPDATE_OTA_ID';

export const UPDATE_OTA_STORE_ID = 'UPDATE_OTA_STORE_ID';

export const UPDATE_OTA_ORDER_NUM = 'UPDATE_OTA_ORDER_NUM';

export const UPDATE_OTA_APPLICANT_COUNT = 'UPDATE_OTA_APPLICANT_COUNT';

export const RESET_OTA_ORDER = 'RESET_OTA_ORDER';

export const UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD = 'UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD';

export const ADD_NEW_FLIGGY_ORDER_APPLICANT = 'ADD_NEW_FLIGGY_ORDER_APPLICANT';

export const DELETE_NEW_FLIGGY_ORDER_APPLICANT = 'DELETE_NEW_FLIGGY_ORDER_APPLICANT';

export const SELECT_NEW_FLIGGY_ORDER_DEPART_DATE = 'SELECT_NEW_FLIGGY_ORDER_DEPART_DATE';

export const SET_FLIGGY_APPLICANT_MSG = 'SET_FLIGGY_APPLICANT_MSG';

export const RESET_NEW_FLIGGY_ORDER_DATA = 'RESET_NEW_FLIGGY_ORDER_DATA';




// WEBPACK FOOTER //
// ./src/store/modules/order/order-mutation-types.js